import { useComponentDidMount } from './useComponentDidMount';
import { useComponentWillUnmount } from './useComponentWillUnmount';
import { useState } from 'react';

export interface WindowDimensions {
    width: number;
    height: number;
}

const getWindowDimensions = (): WindowDimensions => {
    const width = Math.max(window.innerWidth, document.documentElement.clientWidth);
    const height = Math.max(window.innerHeight, document.documentElement.clientHeight);
    return {
        width,
        height,
    };
};

/**
 * Use this hook to get window innerWidth and innerHeight.
 */
export const useWindowDimensions = (): WindowDimensions => {
    const [windowDimensions, setWindowDimensions] = useState<WindowDimensions>(getWindowDimensions);

    function handleResize() {
        setWindowDimensions(getWindowDimensions());
    }

    useComponentDidMount(() => {
        window.addEventListener('resize', handleResize);
    });

    useComponentWillUnmount(() => window.removeEventListener('resize', handleResize));

    return windowDimensions;
};
